"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

//
//  Text.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 1/21/21.
//  Copyright © 2021-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var propDoc = {
  weight: {
    required: false,
    type: "FontWeight",
    defaultValue: "regular",
    description: "Controls the weight of the font that appears"
  },
  renderAsSpan: {
    required: false,
    type: "boolean",
    description: "If true renders children in <span>, otherwise in <div>"
  }
};
var demoProps = {
  weight: "regular"
};

var Text = function Text(props) {
  var children = props.children,
      className = props.className,
      style = props.style,
      renderAsSpan = props.renderAsSpan;
  var styles = useStylesheet(props);
  return renderAsSpan ? /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _styling.css)(styles.root, className, style)
  }, children) : /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, children);
};

Text.propDoc = propDoc;
Text.demoProps = demoProps;
var _default = Text;
exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref) {
  var _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? "regular" : _ref$weight;

  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts;

  var fontFamily = fonts[weight];
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        fontFamily: fontFamily,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.43,
        letterSpacing: "normal"
      }
    });
  }, [fontFamily]);
};